<template>
  <div class='order-list'>
    <h2 class='title'>订单查询</h2>
    <!-- header -->
    <div class='header'>
      <!-- 查询类型 -->
      <div class='search-type'>
        <div class='search-type-item' @click='toggleSearchType("GROUP")'>
          <img v-if='searchType === "GROUP"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>班级查询</span>
        </div>
        <div class='search-type-item' @click='toggleSearchType("PERSON")'>
          <img v-if='searchType === "PERSON"' src='../assets/imgs/selected_on.png' alt='' class='icon'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon'>
          <span>个人查询</span>
        </div>
      </div>
      <!-- 班级查询 options -->
      <div v-if='searchType==="GROUP"' class='group-header'>
        <ul class='row'>
          <li class='item'>
            <span class='label'>学校<i>*</i>：</span>
            <select v-model='selectedSchool' class='select' @change='selectSchool'>
              <option value='-1' disabled>请选择学校</option>
              <option v-for='(item,index) in schoolOptions' :key='index' :value='item.id'>{{ item.name }}</option>
            </select>
          </li>
          <li class='item'>
            <span class='label'>院系<i>*</i>：</span>
            <select v-model='selectedCollege' class='select' @change='selectCollege' @focus='focusCollege'>
              <option value='-1' disabled>请选择院系</option>
              <option v-for='(item,index) in collegeOptions' :key='index' :value='item.id'>{{ item.name }}</option>
            </select>
          </li>
          <li class='item'>
            <span class='label'>专业班级<i>*</i>：</span>
            <select v-model='selectedCls' class='select' @change='selectCls' @focus='focusCls'>
              <option value='-1' disabled>请选择专业班级</option>
              <option v-for='(item,index) in clsOptions' :key='index' :value='item.id'>{{ item.name }}</option>
            </select>
          </li>
          <li class='btn-wrapper'>
            <a href='javascript:;' class='btn-search' @click='searchOrder'>查询</a>
          </li>
        </ul>
        <ul class='row'>
          <li class='item'>
            <span class='label'>批发单号：</span>
            <input v-model='wholesale_no' class='input' type='text' placeholder='请输入批发单号'>
          </li>
          <li class='item'>
            <span class='label'>书号：</span>
            <input v-model='book_no' class='input' type='text' placeholder='请输入书号'>
          </li>
          <li class='item'/>
          <li class='btn-wrapper'/>
        </ul>
      </div>

      <!-- 个人查询 options-->
      <div v-else class='person-header'>
        <ul class='row'>
          <li class='item'>
            <span class='label'>姓名<i>*</i>：</span>
            <input v-model='name' class='input-person' type='text' placeholder='请输入'>
          </li>
          <li class='item'>
            <span class='label'>学号<i>*</i>：</span>
            <input v-model='student_num' class='input-person' type='text' placeholder='请输入'>
          </li>
          <li class='item'>
            <span class='label'>批发单号：</span>
            <input v-model='wholesale_no' class='input-person' type='text' placeholder='请输入'>
          </li>
          <li class='item'>
            <span class='label'>书号：</span>
            <input v-model='book_no' class='input-person' type='text' placeholder='请输入'>
          </li>
          <li class='btn-wrapper'>
            <a href='javascript:;' class='btn-search' @click='searchOrder'>查询</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- content -->
    <div class='content'>
      <!-- 列表 -->
      <div v-loading='loading' class='table-wrapper'>
        <table class='table'>
          <thead>
            <tr>
              <td v-for='item in tableItems' :key='item.idx' :style='{width:item.width}'>{{ item.label }}</td>
            </tr>
          </thead>

          <tbody v-if='list.length'>
            <tr v-for='(item,index) in list' :key='index'>
              <td v-for='t in tableItems' :key='t.idx' :style='{width:item.width}'>
                <!-- 选中/未选中图标 -->
                <div v-if='t.props === "isSelected"' class='cell'>
                  <!-- 已付款不可选中 -->
                  <div v-if='item.status === 1' class='img-wrapper' @click='toggleSelectedStatus(item)'>
                    <img v-if='item.isSelected' src='../assets/imgs/selected_check_on.png' alt='' class='selected-img'>
                    <img v-else src='../assets/imgs/selected_off.png' alt='' class='selected-img'>
                  </div>
                </div>
                <!-- 其他项 -->
                <div v-else class='cell'>
                  {{ item[t.props] | propsFilter(t.props) }}
                </div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>

      </div>
      <!-- 全选 -->
      <div class='select-all'>
        <div class='item-select' @click='selectAll'>
          <img v-if='isAllSelected' src='../assets/imgs/selected_check_on_white_bg.png' alt='' class='icon-select-all'>
          <img v-else src='../assets/imgs/selected_off.png' alt='' class='icon-select-all'>
          <span>全选</span>
        </div>
        <div class='item-info'>合计： 
          <span class='money'>￥{{ totalPrice }}</span> 
        </div>
      </div>
      <page :total='total' @change='changePage'/>
      <div class='btn-checkout-wrapper'>
        <a href='javascript:;' class='btn-checkout' @click='checkout'>结算（{{ totalSelectedNum }}）</a>
      </div>
    </div>

    <!-- 支付 -->
    <select-payment v-if='showSelectedPayment' :total-price='totalPrice' :order-no='orderNo' @cancel='cancelPay' @successCreateQrcode='successCreateQrcode'/>
    <!-- 二维码 -->
    <qrcode v-if='showQrcode' @successpay='successpay' />
  </div>
</template>
<script>
import Page from '@/components/Page'
import SelectPayment from '@/components/SelectPayment'
import Qrcode from '@/components/Qrcode'

import { GROUP_ORDER, PERSON_ORDER, SCHOOL_LIST, COLLEGE_LIST, CLS_LIST } from '@/api'
export default {
  components: {
    Page,
    SelectPayment,
    Qrcode
  },
    
  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'discount':
          result = val + '%'
          break
        case 'total_discount':
          result = '￥' + val
          break
        case 'status':
          result = val === 2 ? '已付款' : '未付款'
          break
        default:
          result = val
          break    
      }
      return result
    }
  },
  data() {
    return {
      selectedSchool: '-1',
      selectedCollege: '-1',
      selectedCls: '-1',
      schoolOptions: [],
      collegeOptions: [],
      clsOptions: [],
      wholesale_no: '',
      book_no: '',
      name: '',
      student_num: '',
      page: 1,
      total: 0,
      loading: false,
      list: [],
      tableItems: [
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 2, label: '选择', props: 'isSelected', width: '50px'},
        { idx: 3, label: '学校', props: 'school', width: '100px'},
        { idx: 4, label: '院系', props: 'department', width: '120px'},
        { idx: 5, label: '年级专业班级', props: 'profession_class',width: '120px'},
        { idx: 6, label: '学号', props: 'student_num', width: '120px'},
        { idx: 7, label: '姓名', props: 'name', width: '100px'},
        { idx: 8, label: '批发单号', props: 'wholesale_no', width: '120px'},
        { idx: 9, label: '书号', props: 'book_no', width: '120px'},
        { idx: 15, label: '索引', props: 'indexes',width: '60px'},
        { idx: 10, label: '书名', props: 'book_name',width: '220px'},
        { idx: 11, label: '丛书名', props: 'series_name',width: '180px'},
        { idx: 12, label: '价格', props: 'total_discount',width: '80px'},
        { idx: 13, label: '折扣', props: 'discount',width: '70px'},
        { idx: 14, label: '数量', props: 'deliver_num',width: '50px'},
        { idx: 16, label: '付款状态', props: 'status',width: '90px'},      // status 1:未付款, 2：已付款;
      ],
      showSelectedPayment: false,  // 显示支付选择
      showQrcode: false,      // 显示付款码
      orderNo: ''
    }
  },

  computed: {
    // 团体 or 个人
    searchType() {
      return this.$store.state.searchType
    },

    // 结算总价
    totalPrice() {
      let totalMoney = 0
      this.list.forEach(e=>{
        if (e.isSelected) totalMoney += (e.total_discount - 0)
      })
      return totalMoney.toFixed(2)
    },

    // 选中的订单总数
    totalSelectedNum() {
      let selectedNum = 0
      this.list.forEach(e=>{
        if (e.isSelected) selectedNum += 1
      })
      return selectedNum
    },

    // 是否全选
    isAllSelected() {
      let flag = true
      this.list.forEach(e=>{
        if ((e.status === 1) && !e.isSelected) flag = false
      })
      return flag
    }

  },

  created() {
    // 初始化查询参数
    this.initSearchInfo()

    // 查询订单
    this.searchOrder()
  },
  methods: {
    // 支付完成
    successpay() {
      this.showQrcode = false
      this.searchOrder()
    },

    // 生成支付二维码 
    successCreateQrcode() {
      this.showSelectedPayment = false
      this.showQrcode = true
    },

    // 取消支付
    cancelPay() {
      this.showSelectedPayment = false
    },

    // 结算
    checkout() {
      let arr = []
      this.list.forEach(e=>{
        if (e.status === 1 && e.isSelected) arr.push(e.order_no)
      })
      if (arr.length === 0) {
        this.$notify('请选择订单','error')
        return
      }

      // 检测登录
      if (!this.checkLogin()) {
        this.$notify('请先登录账号','warning')
        this.goRouter('/my')
        return
      }
      this.orderNo = arr.join()
            
      this.showSelectedPayment = true
    
    },

    // 全选
    selectAll() {
      if (this.isAllSelected) {
        this.list.forEach(e=>{
          if (e.status === 1) {
            e.isSelected = false
          }
        })
      } else {
        this.list.forEach(e=>{
          if (e.status === 1) {
            e.isSelected = true
          }
        })
      }
    },

    // 切换选中 未选中状态
    toggleSelectedStatus(val) {
      this.list.forEach(e=>{
        if (val.idx === e.idx) e.isSelected = !e.isSelected
      })
    },

    // 翻页
    changePage(val) {
      this.page = val
      this.searchOrder()
    },

    // 查询订单
    searchOrder() {
      this.list = []
      if (this.searchType === 'GROUP') this.getGroupOrder()
      else this.getPersonOrder()
    },

    // 查询个人订单
    getPersonOrder() {
      // 表单验证
      if (!this._validatePersonType()) return

      let para = {
        page: this.page,
        name: this.name,
        student_num: this.student_num,
        wholesale_no: this.wholesale_no,
        book_no: this.book_no

      }
      this.loading = true
      PERSON_ORDER(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this._formatList(res.data.data)
          this.total = res.data.total
        }
      })
    },

    // 查询团体订单
    getGroupOrder() {
      // 表单验证
      if (!this._validateGroupType()) return
            
      let para = {
        page: this.page,
        school: this._getSchoolInfoName('SCHOOL',this.$store.state.selectedSchool),
        department: this._getSchoolInfoName('COLLEGE',this.$store.state.selectedCollege),
        profession_class: this._getSchoolInfoName('CLS',this.$store.state.selectedCls),
      }
      if (this.book_no) para.book_no = this.book_no
      if (this.wholesale_no) para.wholesale_no = this.wholesale_no
      this.loading = true
      GROUP_ORDER(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          // 格式化列表
          this._formatList(res.data.data)
          this.total = res.data.total
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        e.isSelected = false
        this.list.push(e)
      })
    },

    // 根据id获取学校、院系、班级名称
    _getSchoolInfoName(type,id) {
      let name
      switch (type) {
        case 'SCHOOL':
          this.schoolOptions.forEach(e=>{
            if (e.id == id) {
              name = e.name
            }
          })
          break
        case 'COLLEGE':
          this.collegeOptions.forEach(e=>{
            if (e.id == id) {
              name = e.name
            }
          })
          break
        case 'CLS':
          this.clsOptions.forEach(e=>{
            if (e.id == id) {
              name = e.name
            }
          })
          break
        default:
          break    
      }
      return name
    },

    // 表单验证-团体订单
    _validateGroupType() {
      if (this.selectedSchool === '-1') {
        this.$notify('请选择学校','warning')
        return false
      }
      if (this.selectedCollege === '-1') {
        this.$notify('请选择院系','warning')
        return false
      }
      if (this.selectedCls === '-1') {
        this.$notify('请选择班级','warning')
        return false
      }
      return true
    },

    // 表单验证-个人订单
    _validatePersonType() {
      if (!this.name) {
        this.$notify('请输入姓名','warning')
        return false
      }
      if (!this.student_num) {
        this.$notify('请输入学号','warning')
        return false
      }
      return true
    },

    // 切换 团体or个人
    toggleSearchType(val) {
      // 个人查询 需登录账号
      if (val === 'PERSON') {
        if (!this.checkLogin()) {
          this.$notify('请先登录账号','warning')
          this.goRouter('/my')
          return
        }
      }
      // 获取学校
      if (val === 'GROUP' && this.schoolOptions.length === 0) {
        this.getSchoolList()
      }
      this.$store.commit('updateStrData',{key: 'searchType', val: val})
      this.selectedSchool = -1
      this.selectedCollege = -1
      this.selectedCls = -1
      this.list = []
    },

    // 监听学院获取焦点事件
    focusCollege() {
      if (this.selectedSchool === '-1') {
        this.$notify('请先选择学校')
      }
    },

    // 监听专业班级获取焦点事件
    focusCls() {
      if ((this.selectedSchool === '-1') || (this.selectedCollege === '-1')) {
        this.$notify('请先选择学校/院系')
      }
    },

    // 获取学校
    getSchoolList() {
      SCHOOL_LIST().then(res=>{
        if (res.data.code === 0) {
          this.schoolOptions = res.data.data
          let payload = {
            type: 'SCHOOL',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取院系
    getCollegeList(para) {
      COLLEGE_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.collegeOptions = res.data.data
          let payload = {
            type: 'COLLEGE',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 获取班级
    getClsList(para) {
      CLS_LIST(para).then(res=>{
        if (res.data.code === 0) {
          this.clsOptions = res.data.data
          let payload = {
            type: 'CLS',
            list: res.data.data
          }
          this.$store.commit('setSchoolInfoList',payload)
        }
      })
    },

    // 选择学校 -> 获取院系
    selectSchool(e) {
      let para = {
        school_id: e.target.value
      }
      this.collegeOptions = []
      this.clsOptions = []
      this.selectedCollege = '-1'
      this.selectedCls = '-1'
      this.getCollegeList(para)
      let payload = {
        type: 'SCHOOL',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择院系 -> 获取专业班级
    selectCollege(e) {
      let para = {
        department_id: e.target.value
      }
      this.clsOptions = []
      this.selectedCls = '-1'
      this.getClsList(para)
      let payload = {
        type: 'COLLEGE',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 选择班级
    selectCls(e) {
      let payload = {
        type: 'CLS',
        item: e.target.value
      }
      this.$store.commit('setSelectedSchoolInfo',payload)
    },

    // 初始化团队查询参数
    initGroupSearchInfo() {
      if (this.$store.state.schoolOptions.length === 0) {
        this.getSchoolList()
      }    

      this.schoolOptions = this.$store.state.schoolOptions
      this.collegeOptions = this.$store.state.collegeOptions
      this.clsOptions = this.$store.state.clsOptions
      this.selectedSchool = this.$store.state.selectedSchool
      this.selectedCollege = this.$store.state.selectedCollege
      this.selectedCls = this.$store.state.selectedCls
      this.wholesale_no = this.$store.state.wholesale_no
      this.book_no = this.$store.state.book_no
    },

    // 初始化个人查询参数
    initPersonSearchInfo() {
      this.wholesale_no = this.$store.state.wholesale_no
      this.book_no = this.$store.state.book_no
      this.name = this.$store.state.name
      this.student_num = this.$store.state.student_num
    },

    // 初始化查询参数
    initSearchInfo() {
      if (this.searchType === 'GROUP') this.initGroupSearchInfo()
      else this.initPersonSearchInfo()
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";

.order-list {
  width: 1200px;

  .title {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }

  .header {
    margin-top: 26px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .search-type {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      .search-type-item {
        height: 32px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 0 15px;
        cursor: pointer;

        .icon {
          margin-right: 15px;
        }
      }
    }

    .person-header,
    .group-header {
      width: 1200px;
      .row {
        height: 42px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 5px 0;

        .item {
          width: 300px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          margin: 10px 0;

          .label {
            display: inline-block;

            i {
              color: red;
            }
          }

          .select {
            box-sizing: border-box;
            display: inline-block;
            flex: 1;
            height: 34px;
            border: 1px solid #dddddd;
            border-radius: 5px;
            background: #ffffff;
            outline: none;
          }

          .input {
            box-sizing: border-box;
            display: inline-block;
            flex: 1;
            height: 34px;
            outline: none;
            border: 1px solid #dddddd;
            border-radius: 5px;
            text-indent: 5px;
          }

          .input-person {
            box-sizing: border-box;
            display: inline-block;
            width: 180px;
            height: 34px;
            outline: none;
            border: 1px solid #dddddd;
            border-radius: 5px;
            text-indent: 5px;
          }
        }

        .btn-wrapper {
          width: 88px;
          .btn-search {
            display: inline-block;
            width: 88px;
            height: 30px;
            line-height: 30px;
            border-radius: 5px;
            font-size: 18px;
            color: #fff;
            background-color: @blue-d;
            text-align: center;
          }
        }
      }
    }
  }

  .content {
    width: 1200px;
    height: 600px;
    margin-top: 10px;
    overflow: hidden;

    // 列表
    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      position: relative;

      .table {
        width: 1500px;
        table-layout: fixed;
        border: 1px solid #999;
        font-size: 14px;
        text-align: center;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          .selected-img {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }
    .select-all {
      height: 35px;
      background-color: @blue-m;
      font-size: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px 0 68px;

      .item-select {
        height: 35px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        .icon-select-all {
          width: 16px;
          height: 16px;
          border-radius: 10px;
          background: #fff;
          margin-right: 26px;
        }
      }

      .item-info {
        .money {
          font-size: 20px;
          font-weight: 500;
        }
      }
    }

    // 结算按钮
    .btn-checkout-wrapper {
      width: 1200px;
      height: 35px;
      line-height: 35px;
      text-align: center;

      .btn-checkout {
        display: inline-block;
        width: 250px;
        height: 35px;
        font-size: 18px;
        color: #fff;
        background: @blue-d;
        border-radius: 5px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderSearchResult.vue